import { render, staticRenderFns } from "./CowsDewormingFirstPage.vue?vue&type=template&id=1e919e2c&scoped=true&"
import script from "./CowsDewormingFirstPage.vue?vue&type=script&lang=js&"
export * from "./CowsDewormingFirstPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e919e2c",
  null
  
)

export default component.exports